import { useCallback, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { enqueueSnackbar } from '~/utils/notifications';

export type OpenNotify = (
    id: string,
    variant: 'warning' | 'error',
    values?: Record<string, number>,
    persist?: boolean
) => void;

/**
 * Snackbar notifier for the open-in-viewer hooks. `intl` is read through a
 * ref, so the returned function is stable and never an effect dependency.
 */
export function useOpenNotify(): OpenNotify {
    const intl = useIntl();
    const intlRef = useRef(intl);
    useEffect(() => {
        intlRef.current = intl;
    });

    return useCallback(
        (
            id: string,
            variant: 'warning' | 'error',
            values?: Record<string, number>,
            persist = false
        ): void => {
            enqueueSnackbar(intlRef.current.formatMessage({ id }, values), {
                variant,
                ...(persist ? { persist: true } : {}),
            });
        },
        []
    );
}
